import { render, staticRenderFns } from "./ProductCrud.vue?vue&type=template&id=5eb07faa"
import script from "./ProductCrud.vue?vue&type=script&lang=js"
export * from "./ProductCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports